import React, { useState } from "react";
import { Box, Button, Paper, Stack, Switch, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import SaveIcon from "@mui/icons-material/Save";
import { useWindowSize } from "../../../shared/hooks/useWindowSize";
import { useSelector } from "react-redux";
import { selectWorkshopDetails } from "../../../app/store/userSlice";
import { useUpdateWorkshopMutation } from "../../../app/store/api/workshopApi";
import toast from "react-hot-toast";

const WorkshopStatus = () => {
  const { t } = useTranslation();
  const { isMobile } = useWindowSize();
  const workshopDetails = useSelector(selectWorkshopDetails);
  const [active, setActive] = useState(workshopDetails?.active);
  const isDirty = active !== workshopDetails?.active;
  const [updateWorkshop, { isLoading: saving }] = useUpdateWorkshopMutation();

  const handleSave = async () => {
    const payload = { active };
    toast.promise(
      async () => {
        await updateWorkshop({ workshopId: workshopDetails.id, payload }).unwrap();
      },
      {
        success: t("toastMessage.saveSuccess"),
        loading: t("toastMessage.saveLoading"),
        error: t("toastMessage.saveError"),
      },
    );
  };

  return (
    <Paper variant='outlined' sx={{ borderColor: active ? "#15803D" : "#B91C1C", borderRadius: 2, p: 3, mb: 4, backgroundColor: active ? "#E7F6EC" : "#FDEAEA" }}>
      <Box>
        <Typography variant='subtitle1' sx={{ fontWeight: 700, color: "#003C59", lineHeight: 1.3 }}>
          {t("workshopStatus.title")}
        </Typography>
      </Box>
      <Box>
        <Stack
          direction={isMobile ? "column" : "row"}
          alignItems={isMobile ? "flex-start" : "center"}
          spacing={2}
          sx={{
            py: 1,
            justifyContent: "space-between",
          }}
        >
          <Box>
            <Typography variant='body2' sx={{ fontWeight: 400, color: "text.primary", lineHeight: 1.3 }}>
              {t("workshopInfo.activeDescription")}
            </Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Typography>{active ? t("workshopInfo.active") : t("workshopInfo.inactive")}</Typography>
            <Switch
              checked={active}
              onChange={() => setActive(!active)}
              sx={{
                "& .MuiSwitch-switchBase.Mui-checked": { color: "#003C59" },
                "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": { bgcolor: "#003C59" },
              }}
            />
          </Box>
        </Stack>
      </Box>
      <Button variant='contained' startIcon={<SaveIcon fontSize='small' />} onClick={handleSave} disabled={saving || !isDirty} sx={{ bgcolor: "#003C59", "&:hover": { bgcolor: "#003C59" } }}>
        {t("workshopSettings.save")}
      </Button>
    </Paper>
  );
};

export default WorkshopStatus;
